const API_URL = 'http://localhost/exacthours/api';
module.exports = {
  API_URL
};